import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/callbot/PageContent.tsx");
